import React from 'react';
import PropTypes from 'prop-types';
import s from './SocialSharingMobile.scss';
import Socialsharing from '../../../../articleshow_v2/components/common/SocialWidget';
import SocialSharingNative from '../../../../articleshow_v2/components/common/SocialSharingNative';

class SocialSharingMobile extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Socialsharing {...this.props} styles={s}>
          {!this.props.hideFollowUsNative && (
            <>
              {!this.props.hideSharingButtons && (
                <SocialSharingNative {...this.props} theme="astheme" />
              )}
              {this.props.hideSharingButtons &&
                this.props.hideSharingNative && (
                  <SocialSharingNative {...this.props} theme="astheme" />
                )}
            </>
          )}
        </Socialsharing>
      </React.Fragment>
    );
  }
}

SocialSharingMobile.propTypes = {
  hideSharingButtons: PropTypes.bool,
  hideSharingNative: PropTypes.bool,
  hideFollowUsNative: PropTypes.bool,
};
SocialSharingMobile.defaultProps = {
  hideSharingButtons: false,
  hideSharingNative: false,
  hideFollowUsNative: false,
};

export default SocialSharingMobile;
